import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { LoaderComponent } from '@modules/shared/loader/loader.component';
import { Store } from '@ngrx/store';
import { AuthAppRedirectService } from '@services/auth-app-redirect.service';
import { StatisticsHttpService } from '@services/http/statistics.http.service';
import { TuiButton, TuiIcon, TuiLink, TuiTitle } from '@taiga-ui/core';
import { TuiCardLarge } from '@taiga-ui/layout';
import { first } from 'rxjs';
import { HelpActionsService } from 'src/app/services/help-actions.service';
import { homeStatistics } from 'src/app/shared/models/home-statistics/home-statistics.config';
import { selectClientCode } from 'src/app/shared/store/router/router.selectors';

@Component({
  templateUrl: './home.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [HelpActionsService],
  imports: [
    TranslocoDirective,
    TuiTitle,
    TuiButton,
    RouterLink,
    TuiCardLarge,
    NgClass,
    TuiIcon,
    LoaderComponent,
    NgTemplateOutlet,
    TuiLink,
    AsyncPipe,
  ],
})
export class HomeComponent {
  private readonly store = inject(Store);
  private readonly authenticationService = inject(AuthenticationService);
  private readonly router = inject(Router);
  private readonly helpActionsService = inject(HelpActionsService);
  private readonly statisticsService = inject(StatisticsHttpService);
  private readonly authAppRedirectService = inject(AuthAppRedirectService);

  readonly userStatistics$ = this.statisticsService.getUserStatistics();
  readonly user = this.authenticationService.user;
  readonly clientCode$ = this.store.select(selectClientCode);

  readonly stats = homeStatistics;

  readonly helpActions = this.helpActionsService.getActions();

  openAccount(): void {
    this.authAppRedirectService.openAccount();
  }

  createSequence(): void {
    this.clientCode$.pipe(first()).subscribe((clientCode) =>
      this.router.navigate(['/client', clientCode, 'sequences'], {
        queryParams: {
          create: true,
        },
      }),
    );
  }
}
